import { render, staticRenderFns } from "./AdmisionRegistroAptitud.vue?vue&type=template&id=63c5d7a3"
import script from "./AdmisionRegistroAptitud.vue?vue&type=script&lang=js"
export * from "./AdmisionRegistroAptitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports